import React from 'react';
import { useMemo, useCallback, useEffect, useState } from 'react';
import DialogBox from '../win/DialogBox';
import { useIsolatedState } from '../win/includes/customHooks';
import WindowManager from '../win/WindowManager';

const ProgramManager = ({ params, programs, onOpenWindow, onMenuAction, windowA, handleExit, subPrograms, windowId, windowName,
		setStateAndSave,
	providerKey,
	setWindowMenu,
	programData,
	setProgramData,
	handleOpenArray,
	onWindowDataChange,
	parentOnOpenWindow,
	initialSubWindows,
	...rest
}) => {

	const [showAboutDialog, setShowAboutDialog] = useState(false);

	//const onOpenWindow = params.onOpenWindow;

	const [showHelpDialog, setShowHelpDialog] = useState(false);

	const menu = useMemo(() => [
		{
			label: 'File',
			submenu: [
				{ label: 'Exit', action: 'exit', menuOrder: 1000 },
				...programs.filter((program) => program.menuOnly === true).map((program) => ({
					label: program.menuLabel,
					fAction: () => onOpenWindow(program,{}, true)
				})),
			],
		},
		{
			label: 'Help',
			submenu: [
				{ label: 'Getting Started', action: 'help', menuOrder: 100 },
				{ label: 'Documentation...', action: 'docs', menuOrder: 200 },
				{ label: 'Source Code...', action: 'source', menuOrder: 900 },
				{ label: 'About', action: 'about', menuOrder: 1000 },
			],
		}
	], []);

	// Handle menu actions (Copy/Paste)
	const handleMenuClick = useCallback((action) => {

		// const currentInput = currentRef.current; // Get the current input from `useRef`

		switch (action) {
			case 'exit':
				handleExit();
				break;
			case 'about':
				setShowAboutDialog(true);
				break;
			case 'help':
				setShowHelpDialog(true);
				break;
			case 'docs':
				window.open('https://github.com/Rotwang9000/WINBIT32/wiki', '_blank');
				break;
			case 'source':
				window.open('https://github.com/Rotwang9000/WINBIT32', '_blank');
				break;
			default:
				break;
		}
	}, []);

	// Notify parent about the menu structure and click handler
	useEffect(() => {
		if (onMenuAction) {
			onMenuAction(menu, windowA, handleMenuClick); // Pass menu and click handler
		}
	}, []);



	// Filter out "Desk" itself to avoid recursion
	const [currentSubWindows, setCurrentSubWindows] = useIsolatedState(windowId, 'subWindows', subPrograms.filter((p) => p.progName !== 'desk.exe'));
	const [handleSubProgramClick, setHandleSubProgramClick] = useState(() => { });



	const handleSetSubProgramClick = useCallback((handle) => {
		setHandleSubProgramClick(() => handle);
	}, []);

	useEffect(() => {
		if (initialSubWindows) {
			setCurrentSubWindows(initialSubWindows);
		}
	}, [initialSubWindows]);

	const filteredSubPrograms = useMemo(
		() => subPrograms.filter((p) => p.progName !== 'desk.exe'),
		[subPrograms]
	);

	useEffect(() => {
		setCurrentSubWindows(filteredSubPrograms);
	}, [filteredSubPrograms]);

	return (
		<>

				<div className={`sub-window-area-${windowId}`}>
					<WindowManager
						programs={currentSubWindows}
						windowName={`sub-window-area-${windowName}`}
						onStateChange={onWindowDataChange}
						handleOpenFunction={handleSetSubProgramClick}
						setStateAndSave={setStateAndSave}
						providerKey={providerKey}
						setWindowMenu={setWindowMenu}
						programData={programData}
						setProgramData={setProgramData}
						handleOpenArray={handleOpenArray}
						onOpenWindow={onOpenWindow}
						windowA={windowA}
						{...rest}
					/>
				</div>

		{showAboutDialog &&
				<DialogBox title="About Winbit32" buttons={[{ label: 'OK', onClick: ()=>setShowAboutDialog(false) }]} onConfirm={() => {
			setShowAboutDialog(false);
		}} onCancel={() => {}} onClose={() => {}} showMinMax={false}>
			<div style={{ textAlign: 'center', marginBottom: '10px', display: 'flex', flexDirection: 'column' }}>
						<img src="/sheildlogobsml.png" alt="Winbit32" style={{marginLeft: '50px', marginRight: '50px', marginTop: '20px' }} />
					<div style={{ fontSize: '1.5em', fontWeight: 'bold' }}>Winbit32</div>
					<div>version {require('../../../package.json').version || "0.0.0"}</div>
				<div>
						<a href="https://x.com/WinBit32" target="_blank" rel="noreferrer">Goto X Profile</a></div>
						</div>
		</DialogBox>
		}
		{showHelpDialog &&
			<DialogBox title="Winbit32 Help" buttons={[{ label: 'OK', onClick: () => setShowHelpDialog(false) }]} onConfirm={() => setShowHelpDialog(false)} onCancel={() => {}} onClose={() => {}} showMinMax={false}>
				<div style={{ padding: '8px', fontFamily: 'MS Sans Serif, sans-serif', fontSize: '12px', maxWidth: 380 }}>
					<h3 style={{ margin: '0 0 8px', fontSize: '14px' }}>Getting Started</h3>
					<p style={{ margin: '0 0 6px' }}>
						<strong>Money Manager</strong> &ndash; Connect your wallet, view balances,
						and perform cross-chain swaps. Use <em>Exora</em> for batch operations.
					</p>
					<p style={{ margin: '0 0 6px' }}>
						<strong>Privacy Suite</strong> &ndash; Shield and unshield ZEC, send
						private transactions, and manage Zcash addresses. Monero support
						lands alongside the THORChain Monero pool — vaults created today
						already carry the Monero FROST share inside their <code>.wult</code>
						file.
					</p>
					<hr style={{ border: '1px inset #ccc', margin: '8px 0' }} />
					<p style={{ margin: '0 0 6px' }}>
						<strong>Connecting a wallet:</strong> Open Money Manager, then use the
						toolbar to connect via browser extension (MetaMask, Keplr, etc.),
						WalletConnect, or enter a recovery phrase directly.
					</p>
					<p style={{ margin: '0 0 6px' }}>
						<strong>Swapping tokens:</strong> Select source &amp; destination tokens,
						enter an amount, and choose from the available routes.
					</p>
					<hr style={{ border: '1px inset #ccc', margin: '8px 0' }} />
					<p style={{ margin: 0, fontSize: '11px', color: '#666' }}>
						For more details, visit{' '}
						<a href="https://github.com/Rotwang9000/WINBIT32/wiki" target="_blank" rel="noreferrer">
							Documentation
						</a>{' '}
						or{' '}
						<a href="https://x.com/WinBit32" target="_blank" rel="noreferrer">
							follow us on X
						</a>.
					</p>
				</div>
			</DialogBox>
		}
		</>
	);
};

export default ProgramManager;
